/**
 * The application's addressable contexts.
 *
 * A route names **what is loaded** — a connector patient, a session, or files
 * from this machine. Which workflow step is being shown is a view of that
 * context, so it travels as the `step` search parameter rather than as a path
 * segment: a path segment claims a different resource, and a step is not one.
 *
 * `:patientId` is the connector's surrogate id. The DICOM Patient ID is PHI and
 * belongs in no URL, no history entry and no referrer — the same rule
 * SR-WOR-H-18-5 applies to the request path.
 */

export const PATIENT_LIST_PATH = '/patients';

/** Viewer on a connector patient. */
export const PATIENT_VIEWER_PATH = '/patients/:patientId';

/** Viewer on a Contour+ session. */
export const SESSION_VIEWER_PATH = '/session/:sessionId';

/**
 * Viewer on files from this machine, backed by no patient record — where a
 * local DICOM drop lands, and where importing it will live.
 */
export const LOCAL_VIEWER_PATH = '/local';

export const patientViewerPath = (patientId: string): string =>
    `${PATIENT_LIST_PATH}/${encodeURIComponent(patientId)}`;

export const sessionViewerPath = (sessionId: string): string =>
    `/session/${encodeURIComponent(sessionId)}`;
